import { applyMiddleware, compose, createStore } from 'redux'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'
import rootReducer from './Reducers/RootReducer'

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['app'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

function configureStore() {
  const store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(thunk)),
  )
  const persistor = persistStore(store)

  if (!localStorage.getItem('leadgrid-version')) {
    localStorage.setItem('leadgrid-version', '2')
    persistor.purge()
  }

  return { store, persistor }
}

export default configureStore
